export const POA_CONSTANTS = {
  COMPANY_NAME: 'Al-Shomoukh Holding Company',
  COMPANY_NAME_AR: 'شركة الشموخ القابضة',
  DATE: 'Date',
  DATE_AR: 'التاريخ',
  GREETING: 'Greetings and may God bless you.',
  GREETING_AR: 'السلام عليكم ورحمة الله وبركاته،',
  TITLE: 'Power of Attorney for Financial Transactions',
  TITLE_AR: 'توكيل ببيع بضاعة',
  BODY_EN:
    'Therefore, we authorize <strong>Al-Shomoukh Holding Company</strong> or its representative to sell the mentioned goods at the current price, collect the proceeds, and deposit the amount into the account of the customer. Below are the financial details of the authorized individual I appointed to receive the amount.',
  BODY_AR:
    'عليه فإننا نوكل <strong>شركة الشموخ القابضة</strong> أو من يفوضه في أن يقوم نيابة عما ببيع البضاعة المذكورة بثمن حال وقبض الثمن وايداع المبلغ بحساب العميل. ومرفق ادناه البيانات المالية للمفوض من قبلي لاستلام المبلغ.',
  CUSTOMER_NAME: 'Customer Name',
  CUSTOMER_NAME_AR: 'اسم العميل',
  IBAN_NUMBER: 'IBAN Number',
  IBAN_NUMBER_AR: 'رقم الايبان',
  CIVIL_ID: 'Civil ID Number',
  CIVIL_ID_AR: 'بطاقة مدنية رقم',
  MOBILE_NUMBER: 'Mobile Number',
  MOBILE_NUMBER_AR: 'رقم الموبايل',
  SIGNATURE: 'Signature',
  SIGNATURE_AR: 'التوقيع',
  BANK_COMPANY_NAME: 'Name of the bank/company',
  BANK_COMPANY_NAME_AR: 'Name of the bank/company in Arabic',
};

export const POA_STYLE_RULES = [
  // Header
  { selector: '.poa-header-section', styles: { 'text-align': 'left', direction: 'ltr' } },

  // Date and Bank Section
  { selector: '.poa-date-table', styles: { border: 'none' } },
  { selector: '.poa-date-table td', styles: { border: 'none' } },
  { selector: '.date-label', styles: { 'text-align': 'left', direction: 'ltr', 'font-family': 'inherit' } },
  { selector: '.bank-name', styles: { 'text-align': 'left', direction: 'ltr', 'font-family': 'inherit' } },
  { selector: '.date-label-ar', styles: { 'text-align': 'right', direction: 'rtl', 'font-family': 'inherit' } },
  { selector: '.bank-name-ar', styles: { 'text-align': 'right', direction: 'rtl', 'font-family': 'inherit' } },
  { selector: '.date-label-ar strong', styles: { direction: 'ltr', display: 'inline-block' } },

  // Greeting Section
  { selector: '.greeting-en', styles: { 'text-align': 'left', direction: 'ltr' } },
  { selector: '.greeting-ar', styles: { 'text-align': 'right', direction: 'rtl' } },

  // Title Section
  { selector: '.poa-title-section', styles: { 'text-align': 'center', direction: 'ltr' } },
  { selector: '.title-en', styles: { 'text-align': 'center', direction: 'ltr' } },
  { selector: '.title-ar', styles: { 'text-align': 'center', direction: 'rtl', display: 'block', width: '100%' } },
  { selector: '.title-ar.arabic-content', styles: { 'text-align': 'center', direction: 'rtl' } },

  // Body Section
  { selector: '.poa-body-table', styles: { border: 'none', 'table-layout': 'fixed' } },
  { selector: '.poa-body-table td', styles: { border: 'none' } },
  { selector: '.body-en', styles: { 'text-align': 'justify', direction: 'ltr' } },
  { selector: '.body-ar', styles: { 'text-align': 'justify', direction: 'rtl' } },

  // Details Section - Critical positioning rules
  { selector: '.poa-details-table', styles: { border: 'none', 'table-layout': 'fixed', width: '100%' } },
  { selector: '.poa-details-table td', styles: { border: 'none' } },

  {
    selector: '.details-label-cell',
    styles: {
      width: '20%',
      'text-align': 'left',
      direction: 'ltr',
      border: 'none',
      'padding-left': '0',
    },
  },
  {
    selector: '.details-value-cell',
    styles: {
      width: '60%',
      'text-align': 'center',
      direction: 'ltr',
      border: 'none',
      'border-bottom': '1px dashed #000',
    },
  },
  {
    selector: '.details-arabic-label',
    styles: {
      width: '20%',
      'text-align': 'right',
      direction: 'rtl',
      border: 'none',
      'padding-right': '0',
    },
  },

  { selector: '.poa-details-table tr:nth-child(3) td', styles: { 'padding-top': '80px' } },

  // Signature Section
  { selector: '.poa-signature-section', styles: { 'text-align': 'left', direction: 'ltr' } },
  { selector: '.signature-label', styles: { 'text-align': 'left', direction: 'ltr', 'padding-left': '0' } },
  { selector: '.signature-line', styles: { 'text-align': 'left', direction: 'ltr', 'padding-left': '0' } },

  // Pagination/Footer Section
  {
    selector: '.poa-footer',
    styles: {
      position: 'absolute',
      bottom: '60px',
      right: '48px',
      left: '48px',
      display: 'flex',
      'justify-content': 'flex-end',
      'align-items': 'center',
    },
  },
  { selector: '.poa-pagination', styles: { 'font-size': '12px', color: '#666', 'text-align': 'right', direction: 'ltr' } },

  // General Arabic content
  { selector: '.arabic-content', styles: { 'text-align': 'right', direction: 'rtl' } },

  // Override for specific centered Arabic content
  { selector: '.poa-title-section .arabic-content', styles: { 'text-align': 'center' } },
];
